import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { guardedCustomElement } from '../utils/guarded-custom-element';
import { styles } from './sds-loader.styles';

type LoaderSize = 'large' | 'medium' | 'small' | 'lg' | 'md' | 'sm';

export interface SDSLoaderProps {
	size?: LoaderSize;
	contrast?: boolean;
}

@guardedCustomElement('sds-loader')
export class SDSLoader extends LitElement {
	static override styles = [styles];

	@property({ type: String, reflect: true }) size: LoaderSize = 'md';
	@property({ type: Boolean, reflect: true }) contrast: boolean = false;

	override render() {
		return html`<svg aria-label="Laster" class="sds-loader" role="img" viewBox="0 0 50 50">
			<circle class="sds-loader__background" cx="25" cy="25" r="20" fill="none" stroke-width="7"></circle>
			<circle class="sds-loader__circle" cx="25" cy="25" r="20" fill="none" stroke-width="7"></circle>
		</svg>`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'sds-loader': SDSLoader;
	}
}
